// extracted by css-extract-rspack-plugin
export default {"sellerImage":"_5778e6a7"};